import { Divider, Grid, useTheme } from '@mui/material'
import { MenuAddCalendarIcon } from 'assets/icons/menu'
import Popup from 'components/popup/Popup'
import PopupSection from 'components/popup/PopupSection'
import PopupSectionRow from 'components/popup/PopupSectionRow'
import { useCalendarSync } from 'components/providers/CalendarSyncProdivder'
import i18n from 'i18n'
import { t } from 'i18next'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { AccountDoc, UserSettingsDoc } from 'types/api/changes'
import { Model } from 'types/model'

import AccountSection from './AccountSection'
import HelpCenterSection from './HelpCenterSection'
import SettingsSection from './SettingsSection'

export const days = [
  { id: '1', title: t('sunday'), idPrefix: 'first-day-' },
  { id: '2', title: t('monday'), idPrefix: 'first-day-' }
]

interface UserMenuPopupProps {
  open: boolean
  setOpen: (b: boolean) => void
  connectGoogleCalendar: () => void
  children: ReactNode
  userSettings?: Model<UserSettingsDoc>
  account?: Model<AccountDoc>
  connectOutlookCalendar: () => void
  onOpenLinkedCalendars?: () => void
}

function Content({ props }: { props: UserMenuPopupProps }) {
  const { t } = useTranslation()
  const calendarSync = useCalendarSync()
  const theme = useTheme()

  return (
    <Grid flexDirection={'column'} display={'flex'} minWidth={'350px'}>
      <PopupSection popupSectionGap={1}>
        <PopupSectionRow
          actionId="add-calendar-accounts-button"
          title={t('addYourCalendarAccounts')}
          iconClass="icon-regular"
          maxWidthIcon={20}
          actionBg
          engulfEntireRow
          icon={<MenuAddCalendarIcon />}
          action={() => {
            props.setOpen(false)
            if (calendarSync.showProviderPicker)
              calendarSync.showProviderPicker()
          }}
        />
      </PopupSection>
      <SettingsSection
        account={props.account}
        userSettings={props.userSettings}
        setMenuOpen={props.setOpen}
        onOpenLinkedCalendars={props.onOpenLinkedCalendars}
      />
      <HelpCenterSection setPopupOpen={props.setOpen} />
      <Divider
        sx={{ ml: 4, mr: 2, borderColor: theme.palette.border.primary }}
      />
      <AccountSection
        setOpen={props.setOpen}
        account={props.account}
        userSettings={props.userSettings}
      />
    </Grid>
  )
}

export default function UserMenuPopup(props: UserMenuPopupProps) {
  return (
    <Popup
      open={props.open}
      closeOnEscape
      setOpen={props.setOpen}
      placement={i18n.dir() === 'ltr' ? 'right' : 'left'}
      fallbackPlacements={
        i18n.dir() === 'ltr' ? ['right', 'left', 'top'] : ['left', 'top']
      }
      content={<Content props={props} />}
    >
      {props.children}
    </Popup>
  )
}
